import { Card, Tabs, type TabsProps } from '@utilitywarehouse/hearth-react';
import { type ReactNode } from 'react';

import './styles.scss';

interface PanelCommonProps {
  children: ReactNode;
}

const PanelHeading = ({ children }: PanelCommonProps) => {
  return <header className="cbcCalculator__PanelHeader">{children}</header>;
};

const PanelFooter = ({ children }: PanelCommonProps) => {
  return <footer className="cbcCalculator__PanelFooter">{children}</footer>;
};

const PanelContent = ({ children }: PanelCommonProps) => {
  return <div className="cbcCalculator__PanelContent">{children}</div>;
};

type PanelProps = PanelCommonProps & TabsProps;

const Panel = ({
  children,
  value,
  defaultValue,
  onValueChange,
}: PanelProps) => {
  return (
    <Tabs
      value={value}
      defaultValue={defaultValue}
      onValueChange={onValueChange}
      className="cbcCalculator__PanelWrapper"
      size="md"
    >
      <Card
        variant="emphasis"
        colorScheme="neutralStrong"
        paddingNone
        direction="column"
        className="cbcCalculator__Panel"
      >
        {children}
      </Card>
    </Tabs>
  );
};

export { Panel, PanelHeading, PanelFooter, PanelContent };
